import React from "react";
import { GiTakeMyMoney, GiArtificialIntelligence } from "react-icons/gi";
import { SiAntdesign } from "react-icons/si";
import { MdCodeOff, MdProductionQuantityLimits } from "react-icons/md";
import data from "../../config/data.json";
import "./Services.css";

const IconMap = {
  GiTakeMyMoney: GiTakeMyMoney,
  GiArtificialIntelligence: GiArtificialIntelligence,
  SiAntdesign: SiAntdesign,
  MdCodeOff: MdCodeOff,
  MdProductionQuantityLimits: MdProductionQuantityLimits,
};

const Services = () => {
  const whyChooseData = data.why_choose_data;

  const renderIcon = (iconName, size) => {
    if (!iconName) return null;

    const IconComponent = IconMap[iconName];
    return IconComponent ? (
      <IconComponent size={size} color="rgb(41, 197, 234)" />
    ) : null;
  };

  return (
    <section id="services" className="services section" data-builder="section">
      <div
        className="section-title"
        data-aos="fade-up"
        data-builder="section-title"
      >
        <h1 spellCheck="false">{whyChooseData.title}</h1>
        <p spellCheck="false">{whyChooseData.section_paragraph}</p>
      </div>

      <div data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          {whyChooseData.reasons.map((reason, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div
                className="feature-card"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="feature-icon">
                  {renderIcon(reason.icon, reason.icon_size)}
                </div>
                <h3 spellCheck="false">{reason.heading}</h3>
                <p spellCheck="false">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
